module.exports = __webpack_public_path__ + "d6957c80c7cb94a5b05837e5472e082b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/google-classroom.png
// module id = 527
// module chunks = 0